import { render } from "./BasketballFavCard.vue?vue&type=template&id=7c7345fa&scoped=true"
import script from "./BasketballFavCard.vue?vue&type=script&lang=js"
export * from "./BasketballFavCard.vue?vue&type=script&lang=js"

import "./BasketballFavCard.vue?vue&type=style&index=0&id=7c7345fa&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c7345fa"]])

export default __exports__